import React, { Component } from "react";
import PropTypes from "prop-types";

// material-ui
import { withStyles } from "@material-ui/core/styles";

// custom
import Table from "components/Table";

// styles
import styles from "./styles";

class SupportItemTypesList extends Component {
  static propTypes = {
    // classes: PropTypes.object,
    supportItemTypes: PropTypes.array,
    onSelect: PropTypes.func,
  };

  onSelect(selectedSupportItemType) {
    const { onSelect } = this.props;
    if (onSelect) {
      onSelect(selectedSupportItemType);
    }
  }

  render() {
    const { supportItemTypes } = this.props;

    return (
      <Table
        data={supportItemTypes}
        meta={[
          {
            path: "name",
            title: "Name",
            numeric: false,
            hidden: { mdDown: true },
          },
        ]}
        title={"SupportItemTypes"}
        onRowSelect={this.onSelect.bind(this)}
      />
    );
  }
}

export default withStyles(styles)(SupportItemTypesList);
